// extracted by mini-css-extract-plugin
export default {"container":"theme_container__YckS2","resultsContainer":"theme_resultsContainer__QyATU","result":"theme_result__9q5F2","name":"theme_name__lQ-IQ"};